<template>
    <div class="card">
        <!-- <TabView @tab-change="handleTabChange"> -->
            <TabView >
            <TabPanel header="รายละเอียดข้อมูลเจ้าหน้าที่">
                <report-officer-detail></report-officer-detail>
            </TabPanel>
            <TabPanel header="สรุปจำนวนเจ้าหน้าที่">
                <report-officer-amount></report-officer-amount>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import reportOfficerAmount from './ReportOfficerAmount';
import reportOfficerDetail from './ReportOfficerDetail';

export default {
    components: {
        reportOfficerAmount,
        reportOfficerDetail
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>